export const designationLevels = (state, action) => {
    switch (action.type) {
      case 'GET_DESIGNATION_LEVELS':
        return {
          ...state,
          data: action.payload,
        };
      case 'LOADING_ACTION':
        return {
          ...state,
          showLoader: action.payload,
        };
      default:
        return { ...state };
    }
  };